<template>
	<div>
		<pui-datatable
			:modelName="modelName"
			:modelColumnDefs="modelColumnDefs"
		></pui-datatable>
	</div>
</template>

<script>

export default {
	name: 'mgrupoprioridad-grid',
	components: {
	},
	data() {
		return {
			modelName: 'mgrupoprioridad',
			modelColumnDefs: {
			}
		}
	}
}
</script>
